import { Divider } from '@mui/material';
import { Components } from 'react-virtuoso';
import { isTouchEnabled } from '../../../../Theme';
import useProductDetailsStore from '../../../../stores/ProductDetails/productDetails.store';
import { selectIsMassActionBarOpen } from '../../../../stores/ProductDetails/productDetails.store.selectors';
import useCombinationLineStyles from '../components/CombinationLine/styles/combinationLine.styles';
import { PRODUCT_DETAILS_SCROLL_HEADER_HEIGHT } from '../components/ProductDetailsScrollHeader/productDetailsScrollHeader.styles';
import useProductDetailsListComponentsStyles from '../styles/productDetailsListComponents.styles';

const TOP_ITEM_LIST_Z_INDEX = 2;
const GROUP_HEADER_Z_INDEX = 3;

export const getItemHeight = (mobileWidth: boolean) => {
  if (mobileWidth) {
    return 164;
  }

  return isTouchEnabled ? 108 : 56;
};

const productDetailsListComponents: Components = {
  Item: ({ children, ...props }) => {
    const { classes: itemClasses } = useCombinationLineStyles();

    return (
      <div {...props} className={itemClasses.root}>
        {children}
      </div>
    );
  },
  TopItemList: (props) => {
    const { classes } = useProductDetailsListComponentsStyles();
    const isMassActionBarOpen = useProductDetailsStore(selectIsMassActionBarOpen);

    return (
      <div
        className={classes.fixedHeader}
        {...props}
        style={{
          ...props.style,
          display: isMassActionBarOpen ? 'none' : undefined,
          top: PRODUCT_DETAILS_SCROLL_HEADER_HEIGHT,
          zIndex: TOP_ITEM_LIST_Z_INDEX,
        }}
      />
    );
  },
  Group: ({ children, ...props }) => {
    const { classes, cx } = useProductDetailsListComponentsStyles();
    const isMassActionBarOpen = useProductDetailsStore(selectIsMassActionBarOpen);

    const isFirstGroup = props['data-item-index'] === 0;

    return (
      <div
        {...props}
        id="product-details-header-group"
        data-first-group={isFirstGroup}
        className={classes.groupHeader}
        style={{
          ...props.style,
          position: isMassActionBarOpen ? 'static' : 'sticky',
          zIndex: GROUP_HEADER_Z_INDEX,
        }}
      >
        <Divider
          id="product-details-header-group-divider"
          className={cx(classes.groupDivider, { [classes.hideGroupDivider]: isFirstGroup })}
        />
        {children}
      </div>
    );
  },
};

export default productDetailsListComponents;
